var components = {
  uIcon: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
    )
  },
  uBadge: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-badge/u-badge" */ "uview-ui/components/u-badge/u-badge.vue"
    )
  },
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }